import { Menubar } from "radix-ui";
import { Logo } from "../../branding";
import type { NavigationProps } from "../types";
import { TopbarNavigationItem } from "./topbar-navigation-item";
import { TopbarNavigationMenu } from "./topbar-navigation-menu";
import type { PropsWithChildren } from "react";

export function TopbarNavigation({
	navigationItems,
	menuItems,
	children,
}: NavigationProps & PropsWithChildren) {
	/** Render */
	return (
		<div className="w-full p-4 h-stack gap-12">
			<Logo />
			<Menubar.Root className="h-stack">
				{navigationItems.map((item) => (
					<TopbarNavigationItem
						navigationItem={item}
						key={item.label}
					/>
				))}
			</Menubar.Root>
			<div className="flex-1 h-stack justify-end gap-4">
				{children}
				<TopbarNavigationMenu menuItems={menuItems} />
			</div>
		</div>
	);
}
